/* 
  data: 传入进来的数据源
  output: 输出给业务端的html结构代码
*/
export const Test = (data: any): any => {
  console.log(data)
  const output = '<h1>this is h1 lable</h1>';
  return new Promise((resolve) => {
    resolve(output)
  })
}